var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54797 6.45659C5.15709 3.60929 5.96165 2.18564 7.0657 1.81917C7.67303 1.61757 8.3273 1.61757 8.93463 1.81917C10.0387 2.18564 10.8432 3.60929 12.4524 6.45659C14.0615 9.30385 14.866 10.7275 14.6247 11.8875C14.4919 12.5257 14.1648 13.1045 13.6902 13.5411C12.8275 14.3347 11.2184 14.3347 8.00017 14.3347C4.78193 14.3347 3.17281 14.3347 2.31014 13.5411C1.83555 13.1045 1.50843 12.5257 1.37565 11.8875C1.13429 10.7275 1.93885 9.30385 3.54797 6.45659Z",
    stroke: "#FF3B2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99463 10.668H8.00063",
    stroke: "#FF3B2D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.66669V6",
    stroke: "#FF3B2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.2421152b801dea29da3e820d0cd5ee52.svg";
export { ForwardRef as ReactComponent };